import { parsePropertyTimestamp } from './properties';

/** Parse admin table timestamps (ISO strings, Firestore shapes, epoch ms). */
export const parseAdminTimestamp = (value) => parsePropertyTimestamp(value);

/**
 * Filter records by year / month / day (same semantics as live listings).
 * @param {Date|null} at - Parsed timestamp for the record
 * @param {{ mode?: string, year?: string, month?: string, date?: string }} filter
 */
export const timestampMatchesAdminDateFilter = (at, { mode, year, month, date } = {}) => {
  if (!mode || mode === 'all') return true;
  if (!at) return false;

  if (mode === 'year') {
    if (!year) return true;
    const y = Number(year);
    if (!y) return true;
    return at.getFullYear() === y;
  }
  if (mode === 'month') {
    if (!month) return true;
    const [y, mon] = month.split('-').map((part) => Number(part));
    if (!y || !mon) return true;
    return at.getFullYear() === y && at.getMonth() + 1 === mon;
  }
  if (mode === 'date') {
    if (!date) return true;
    const [y, mon, day] = date.split('-').map((part) => Number(part));
    if (!y || !mon || !day) return true;
    return at.getFullYear() === y && at.getMonth() + 1 === mon && at.getDate() === day;
  }
  return true;
};

/** @param {object} record @param {(object) => unknown} getTimestamp */
export const recordMatchesAdminDateFilter = (record, getTimestamp, filter) => {
  const raw = getTimestamp(record);
  const at = parseAdminTimestamp(raw);
  return timestampMatchesAdminDateFilter(at, filter);
};

export const submissionSubmittedAt = (sub) =>
  sub?.submittedAt || sub?.submittedDate || sub?.createdAt || null;

export const submissionMatchesAdminDateFilter = (sub, filter) =>
  recordMatchesAdminDateFilter(sub, submissionSubmittedAt, filter);

export const userRegisteredAt = (user) => user?.createdAt || null;

export const userMatchesAdminDateFilter = (user, filter) =>
  recordMatchesAdminDateFilter(user, userRegisteredAt, filter);

export const kycSubmittedAt = (row) => row?.submittedAt || row?.createdAt || null;

export const kycMatchesAdminDateFilter = (row, filter) =>
  recordMatchesAdminDateFilter(row, kycSubmittedAt, filter);

export const chatReportFiledAt = (row) => row?.createdAt || null;

export const chatReportMatchesAdminDateFilter = (row, filter) =>
  recordMatchesAdminDateFilter(row, chatReportFiledAt, filter);

export const documentUploadedAt = (row) => row?.createdAt || null;

export const documentMatchesAdminDateFilter = (row, filter) =>
  recordMatchesAdminDateFilter(row, documentUploadedAt, filter);

export const documentAccessRequestedAt = (row) => row?.createdAt || null;

export const documentAccessRequestMatchesAdminDateFilter = (row, filter) =>
  recordMatchesAdminDateFilter(row, documentAccessRequestedAt, filter);

export const documentGrantGrantedAt = (row) => row?.grantedAt || null;

export const documentGrantMatchesAdminDateFilter = (row, filter) =>
  recordMatchesAdminDateFilter(row, documentGrantGrantedAt, filter);

export const documentAccessRevokedAt = (row) => row?.revokedAt || null;

export const documentRevocationMatchesAdminDateFilter = (row, filter) =>
  recordMatchesAdminDateFilter(row, documentAccessRevokedAt, filter);
